import { InterviewSchedule } from "../Entities/interview-schedule.entity";
import { InterviewSession } from "../Entities/interview-session.entity";
import { jobPostRounds } from "../Interface/Index";
import { formatDateTime } from "./generic-functions";
import dayjs from "dayjs";

const getLastPendingRoundInfo = (
  interviewSessions: InterviewSession[],
  rounds: jobPostRounds[],
) => {
  const lastPendingSession = interviewSessions
    .filter((s) => s.status === "pending")
    .sort(
      (a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
    )[0];
  const lastRoundName = rounds.find(
    (r) => r.round._id === lastPendingSession?.interviewRoundId,
  );

  return {
    sessionId: lastPendingSession?._id,
    roundName: lastRoundName?.round.title,
  };
};

const getScheduleInformation = (interviewSchedule: InterviewSchedule) => {
  const { startTime, endTime } = interviewSchedule;

  const date = dayjs(startTime).format("DD MMM YYYY").toUpperCase();
  const start = formatDateTime(startTime);
  const end = formatDateTime(endTime);

  return {
    date,
    start,
    end,
  };
};

export { getLastPendingRoundInfo, getScheduleInformation };
